export default "__VITE_ASSET__94299177__"